var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":"Duration (MS)"}},[_c('LinkedControlItem',{staticClass:"d-block w-100",attrs:{"max":50000,"min":0},model:{value:(_vm.duration),callback:function ($$v) {_vm.duration=$$v},expression:"duration"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }